const menuRouter = [
    /**
     * 系统管理
     **/
    {
        path: '/project',
        meta: { title: '项目设置' },
        component: () => import('@/views/page/project'),
        used: true,
    }
]

export default menuRouter
